export default {
  name: 'StrokedViewIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 16
    },
    color: {
      type: String,
      default: "#616161"
    }
  }
};